<template>
  <layout-default-app-bar 
    filterable
    :filters="filters"
    :back-to="rotaVoltar">
    Produtos
  </layout-default-app-bar>
</template>

<script>
import LayoutDefaultAppBar from '@/layouts/default/AppBar.vue';
import Filters from './Filters.vue';

export default {
  name: 'ViewCadastroPedidoAppBar',

  components: {
    LayoutDefaultAppBar,
  },

  data() {
    return {
      filters: [ Filters ], 
    };
  },

  created() {
    this.verificarRotaDeRetorno();
  },

  methods: {
    verificarRotaDeRetorno() {
      const idPedido = sessionStorage.getItem('retornoIdPedido')
      if (idPedido) {
        let idcliente = sessionStorage.getItem('retornoIdCliente')
        this.rotaVoltar = {
          path: '/cadastro-pedido', 
          query: {
            id: idPedido,
            idcliente: idcliente
          }
        };
      } else {
        this.rotaVoltar = true;
      }
    }
  }
};
</script>